import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  required,
} from 'react-admin';

export const CharacteristicGroupEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="slug" fullWidth helperText="Автоматически генерируется из названия, если не указан" />
      <TextInput source="description" multiline rows={3} fullWidth />
      <NumberInput source="sortOrder" />
    </SimpleForm>
  </Edit>
);
